import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Grid from 'material-ui/Grid';
import { FOIL, CORE_CAP } from  '../../../constants/globals';
import Input from '../../common/Input';
import Radio from '../../common/Radio';
import Slider from '../../common/Slider';
import Button from '../../common/Button';
import ResinPicker from '../../common/ResinPicker';
import StackupPreview from './StackupPreview';
import { toInt } from '../../../lib/helpers';
import {
  getManufacturers,
  getManufacturerIdFromStartNewForm,
  getResinIdFromStartNewForm,
  getIsStartNewFormValid,
  getStartNewFormConfig,
  getResinsByManufacturerId,
  getResinById,
  getDefaultCore,
  getDefaultPrepreg,
} from '../../../reducers';
import { updateStartNewForm } from '../../../actions';
import {
  materialPropType,
  materialWithCountPropType,
  resinPropType,
  startNewFormValuesPropType,
  startNewFormConfigPropType,
  selectOptionPropType
} from '../../../lib/shapes';

export class StartNewForm extends Component {
  handleSubmit(event) {
    event.preventDefault();
    const {
      selectedResin: resin,
      defaultCore:   core,
      defaultPrepreg: prepreg,
      isFormValid,
      startNewForm,
      onSubmit
    } = this.props;
    let stackupSpec;

    if(isFormValid){
      stackupSpec = {
        ...startNewForm,
        resin,
        core,
        prepreg
      }
      onSubmit(event, stackupSpec);
    }
  }

  handleChange(fieldName, valueModifier = (value)=>value){
    const { updateStartNewForm } = this.props;
    return function handler(event){
      const value = event.target === undefined ? event : event.target.value;
      updateStartNewForm(fieldName, valueModifier(value));
    }
  }

  render() {
    const {
      onCancel,
      manufacturerOptions,
      resinOptions,
      config,
      selectedResin: resin,
      startNewForm: form,
      defaultCore: core,
      defaultPrepreg: prepreg,
      isFormValid
    } = this.props;
    const disableSubmit = !isFormValid

    return (
      <form
        noValidate
        autoComplete="off"
        onSubmit={this.handleSubmit.bind(this)}
      >
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Input
              required
              label="Project Name"
              value={form.projectName}
              onChange={this.handleChange('projectName')}
              validations={config.projectName.validations}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              label="Part Number"
              value={form.partNumber}
              onChange={this.handleChange('partNumber')}
            />
          </Grid>
          <Grid item xs={12}>
            <ResinPicker
              required
              manufacturerOptions={manufacturerOptions}
              resinOptions={resinOptions}
              value={form.resin}
              onChange={this.handleChange('resin')}
              validations={config.resin.validations}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6}>
            <StackupPreview
              stackupType={form.stackupType}
              resin={resin}
              prepreg={prepreg}
              core={core}
              numberOfCopperLayers={form.numberOfCopperLayers}
              innerCopperWeight={form.innerCopperWeight}
              outerCopperWeight={form.outerCopperWeight}
            />
          </Grid>
          <Grid item xs={6}>
            <Radio
              label="Stackup Type"
              required
              value={form.stackupType}
              onChange={this.handleChange('stackupType')}
              options={[ FOIL, CORE_CAP ]}
            />
            <Input
              label="Number of Copper layers"
              value={form.numberOfCopperLayers}
              type="number"
              inputProps={{ min: 2, step: 2 }}
              onChange={this.handleChange('numberOfCopperLayers', toInt)}
              validations={config.numberOfCopperLayers.validations}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Slider
              label="Default inner layer copper weight"
              unit="oz"
              min={0.25}
              max={3.0}
              step={0.25}
              precision={2}
              value={form.innerCopperWeight}
              onChange={this.handleChange('innerCopperWeight')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Slider
              label="Default outer layer copper weight"
              unit="oz"
              min={0.25}
              max={3.0}
              step={0.25}
              precision={2}
              value={form.outerCopperWeight}
              onChange={this.handleChange('outerCopperWeight')}
            />
          </Grid>
        </Grid>
        <Grid container justify="flex-end">
          {onCancel && (
            <Button
              default
              label="Cancel"
              type="button"
              onClick={onCancel}
            />
           )}
          <Button
            primary
            disabled={disableSubmit}
            label="Start"
            type="submit"
          />
        </Grid>
      </form>
    );
  }
}

function mapStateToProps(state){
  const manufacturerId = getManufacturerIdFromStartNewForm(state),
    resinId = getResinIdFromStartNewForm(state)
  ;
  return {
    startNewForm: state.startNewForm,
    manufacturerOptions: getManufacturers(state),
    isFormValid: getIsStartNewFormValid(state),
    config: getStartNewFormConfig(),

    resinOptions: getResinsByManufacturerId(state, manufacturerId),
    selectedResin: getResinById(state, resinId),

    defaultCore: getDefaultCore(state, resinId),
    defaultPrepreg: getDefaultPrepreg(state, resinId) ,
  };
}


StartNewForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,

  // props from stateToProps
  startNewForm: PropTypes
    .shape(startNewFormValuesPropType)
    .isRequired,
  manufacturerOptions: PropTypes
    .arrayOf(PropTypes.shape(selectOptionPropType))
    .isRequired,
  isFormValid: PropTypes.bool,
  config:   PropTypes.shape(startNewFormConfigPropType).isRequired,
  resinOptions:   PropTypes
    .arrayOf(PropTypes.shape(selectOptionPropType))
    .isRequired,
  selectedResin: PropTypes.shape(resinPropType),
  defaultCore: PropTypes.shape(materialPropType),
  defaultPrepreg: PropTypes.shape(materialWithCountPropType),
  updateStartNewForm: PropTypes.func.isRequired,
}

StartNewForm.defaultProps = {
  isFormValid: false,
  selectedResin: undefined,
  defaultCore: undefined,
  defaultPrepreg: undefined,
}

export default connect(mapStateToProps, { updateStartNewForm })(StartNewForm);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/StartNew/StartNewForm.js